import React, {useState, useEffect} from 'react';
import ReactCardCarousel from '@homeaway/react-card-carousel';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';
import {reactCarouselBreakPoints} from '../../../utils/carousel-breakpoints';

function getControlOffset(aspectRatio) {
    return (width, controlHeight) =>
        AspectRatioCard.getControlOffset(width, controlHeight, aspectRatio);
}

export function CarouselComponent(props) {
    const [cardIndex, setCardIndex] = useState(0);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (!isClient) {
            setIsClient(true);
        }
    }, [isClient]);

    useEffect(() => {
        setCardIndex(0);
    }, [props.children]);

    function handleNavigation(clickHandler) {
        return (evt, newIndex) => {
            setCardIndex(newIndex);

            if (typeof clickHandler === 'function') {
                clickHandler();
            }
        };
    }

    const {
        children,
        titleMessage,
        subtitleMessage,
        isMobile,
        aspectRatio = '3x4',
        breakpoints = reactCarouselBreakPoints(isMobile),
        onNextClick,
        onPreviousClick,
    } = props;

    const scrolling = isMobile && isClient;

    return (
        <ReactCardCarousel
            breakpoints={breakpoints}
            cardIndex={cardIndex}
            getControlOffset={getControlOffset(aspectRatio)}
            onNextClick={handleNavigation(onNextClick)}
            onPreviousClick={handleNavigation(onPreviousClick)}
            nextLabel={'Next'}
            paging
            previousLabel={'Previous'}
            title={titleMessage}
            subheading={subtitleMessage}
            scrolling={scrolling}
        >
            {children}
        </ReactCardCarousel>
    );
}

export const CardCarousel = determineIfMobile(
    CarouselComponent,
    TABLET_BREAKPOINT
);

CardCarousel.displayName = 'CardCarousel';

export default CardCarousel;
